import '.t{overflow:hidden;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.z{width:100%;}.ssr-plugin'
import '.bx{position:relative;}.ssr-plugin'
import '.e7{width:max-content;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { ReactNode, useRef } from 'react'

export type ScrollingBannerProps = {
  children: ReactNode
  duration?: number
  gap?: string
  style?: Style
}

export const ScrollingBanner = ({
  children,
  duration = 30,
  gap = '2rem',
  style,
}: ScrollingBannerProps) => {
  const innerRef = useRef<HTMLDivElement>(null)

  return (
    <styled.div className="t a z bx"
      style={{
        ...style,
      }}
      onMouseEnter={() => {
        if (innerRef.current) {
          innerRef.current.style.animationPlayState = 'paused'
        }
      }}
      onMouseLeave={() => {
        if (innerRef.current) {
          innerRef.current.style.animationPlayState = 'running'
        }
      }}
    >
      <styled.div className="a e7"
        ref={innerRef}
        style={{
          animation: `scroll-left ${duration}s linear infinite`,
          gap,
        }}
      >
        {children}
        {/* Duplicate content for seamless scrolling */}
        {children}
      </styled.div>
    </styled.div>
  )
}
